import React, { useEffect, useState } from "react";
import { Button, buttonVariants } from "../ui/button";
import { cn } from "@/src/lib/utils";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
// import { CATEGORY_SUB_MENU } from "@/src/Config";
import { Paragraph } from "../common/Paragraph";
import { Utility } from "@/src/utils/utility";
import { usePathname } from "next/navigation";

// type CategorySub = (typeof CATEGORY_SUB_MENU)[number];

interface NavItemProps {
  categoryItem: any;
  handleOpen: () => void;
  close: () => void;
  isOpen: boolean;
  isAnyOpen: boolean;
}

const NavItem = ({
  isAnyOpen,
  categoryItem,
  handleOpen,
  close,
  isOpen,
}: NavItemProps) => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const pathname = usePathname();

  // Check if the screen is small (e.g., xs breakpoint)
  useEffect(() => {
    const updateScreenSize = () => {
      setIsSmallScreen(window.innerWidth < 880); // Adjust to match Tailwind's `sm` breakpoint (640px)
    };

    updateScreenSize(); // Initial check
    window.addEventListener("resize", updateScreenSize);

    return () => {
      window.removeEventListener("resize", updateScreenSize);
    };
  }, []);

  const [selectedItem, setSelectedItem] = useState<any>(
    categoryItem?.children[0],
  );

  const SubMainCategory = ({ categoryItem1 }: { categoryItem1: any }) => {
    return (
      <div className="flex justify-start gap-20">
        <div className="flex flex-col gap-2">
          {categoryItem1?.children?.map((subItem1: any, i: number) => (
            <div
              key={i}
              className="flex"
              onMouseEnter={(e) => {
                e.stopPropagation(); // Prevent event from bubbling up
                setSelectedItem(subItem1); // Set the selected item
              }}
            >
              <Link
                // href={`/${categoryItem1?.slug}/${subItem1?.slug}`}
                href={Utility.getRouteLinkUrl({
                  main: `/${categoryItem1?.slug}/${subItem1?.slug}`,
                  blog: `/blog/${categoryItem1?.slug}/${subItem1?.slug}`,
                  tools: `/tools/${categoryItem1?.slug}/${subItem1?.slug}`,
                  pathname: pathname,
                })}
                className={buttonVariants({
                  variant:
                    selectedItem?.name === subItem1?.name
                      ? "secondary"
                      : "ghost",
                  className: "flex justify-start",
                })}
              >
                {subItem1?.name}
              </Link>
            </div>
          ))}
        </div>

        <SubCategory categoryItem2={selectedItem} />
      </div>
    );
  };

  const SubCategory = ({ categoryItem2 }: { categoryItem2: any }) => {
    return (
      <div className="flex flex-wrap gap-6">
        {(categoryItem2?.children ?? []).map((subCategory: any, i: number) => (
          <div key={i} className="flex flex-col gap-4">
            <h3 className="text-sm font-medium capitalize text-gray-900">
              {subCategory.name}
            </h3>
            <ul className="space-y-5">
              {subCategory?.children?.map((item: any, j: number) => (
                <li key={j}>
                  <Link
                    // href={`/${categoryItem?.slug}/${categoryItem2?.slug}/${subCategory?.slug}/${item?.slug}`}
                    href={Utility.getRouteLinkUrl({
                      main: `/${categoryItem?.slug}/${categoryItem2?.slug}/${subCategory?.slug}/${item?.slug}`,
                      blog: `/blog/${categoryItem?.slug}/${categoryItem2?.slug}/${subCategory?.slug}/${item?.slug}`,
                      tools: `/tools/${categoryItem?.slug}/${categoryItem2?.slug}/${subCategory?.slug}/${item?.slug}`,
                      pathname: pathname,
                    })}
                    className="cursor-pointer text-sm font-light text-black hover:text-main-600 hover:underline"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
            <Link
              // href={`/${categoryItem?.slug}/${categoryItem2?.slug}/${subCategory?.slug}`}
              href={Utility.getRouteLinkUrl({
                main: `/${categoryItem?.slug}/${categoryItem2?.slug}/${subCategory?.slug}`,
                blog: `/blog/${categoryItem?.slug}/${categoryItem2?.slug}/${subCategory?.slug}`,
                tools: `/tools/${categoryItem?.slug}/${categoryItem2?.slug}/${subCategory?.slug}`,
                pathname: pathname,
              })}
              className="capitalize"
            >
              <Paragraph
                as="div"
                className="text-xs font-semibold underline hover:text-main-600"
              >
                {" "}
                {`See all ${subCategory.name}`}
              </Paragraph>
            </Link>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div
      className=""
      onMouseEnter={(e) => {
        e?.stopPropagation();
        if (!isSmallScreen) handleOpen();
      }}
      onMouseLeave={(e) => {
        e?.stopPropagation();
        if (!isSmallScreen) close();
      }}
      onClick={() => {
        if (isSmallScreen) handleOpen();
      }}
    >
      {/* Parent Category Button */}
      <div className="flex items-center pb-2">
        {/* {JSON.stringify(categoryItem)} */}
        <Link
          // href={`/${categoryItem?.slug}`}
          href={Utility.getRouteLinkUrl({
            main: `/${categoryItem?.slug}`,
            blog: `/blog/${categoryItem?.slug}`,
            tools: `/tools/${categoryItem?.slug}`,
            pathname: pathname,
          })}
          // className={buttonVariants({ variant: { isOpen? "secondary": "ghost" } })}
          className={cn(
            buttonVariants({ variant: isOpen ? "secondary" : "ghost" }),
            "capitalize",
          )}
        >
          {categoryItem?.name}
        </Link>
      </div>

      {/* Dropdown Menu */}
      {isOpen && (categoryItem?.children ?? []).length > 0 && (
        <div className="absolute left-0 top-auto z-50 min-h-screen w-full border-t-2 bg-white shadow-lg">
          {/* <div className="grid md:grid-cols-3 lg:grid-cols-5 p-6 max-w-[1440px] mx-40 "> */}
          <div className="mx-auto flex max-w-[2440px] gap-6 p-6 md:justify-center">
            <div className="flex md:w-2/12">
              <Button onClick={close} variant={"outline"}>
                <ArrowRight
                  className={cn(
                    "h-4 w-4 text-muted-foreground transition-all",
                    {
                      "-rotate-180": isOpen,
                    },
                  )}
                />
              </Button>
            </div>

            {/* Loop through children categories */}

            <div className="flex md:w-10/12">
              <SubMainCategory categoryItem1={categoryItem ?? []} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NavItem;

{
  /* {(categoryItem?.children ?? []).map(
              (subCategory: any, i: number) => (
                <div key={i} className="flex flex-col gap-4">
                  <h3 className="text-sm font-medium capitalize text-gray-900">
                    {subCategory.name}
                  </h3>
                  <ul className="space-y-5">
                    {subCategory?.children?.map((item: any, j: number) => (
                      <li key={j}>
                        <Link
                          href={`/${categoryItem?.slug}/${subCategory?.slug}/${item?.slug}`}
                          className="cursor-pointer text-sm font-light text-black hover:text-main-600 hover:underline"
                        >
                          {item.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                  <Link
                    href={`/${categoryItem?.slug}/${subCategory?.slug}`}
                    className="capitalize"
                  >
                    <Paragraph
                      as="div"
                      className="text-xs font-semibold underline hover:text-main-600"
                    >
                      {" "}
                      {`See all ${subCategory.name}`}
                    </Paragraph>
                  </Link>
                </div>
              ),
            )} */
}
